var _style, _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimatedTransfert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 120",
    width: 960,
    height: 360,
    role: "img",
    "aria-label": "Animated transfer from phone to phone",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    @import url('https://fonts.googleapis.com/css2?family=Akatab:wght@400;500;600;700;800;900&amp;family=IBM+Plex+Sans+Arabic:wght@100;200;300;400;500;600;700&amp;family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&amp;family=Montserrat:ital,wght@0,100..900;1,100..900&amp;display=swap');\r\n    \r\n    /* CSS variables for color customization */\r\n    .phone-fill { fill: currentColor; }\r\n    .coin-stroke { stroke: currentColor; }\r\n    .coin-text { fill: currentColor; }\r\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "phone-shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "phone-fill",
    d: "M69.3,8.6H28c-5.3,0-9.7,4.3-9.7,9.6v66.2c0,5.3,4.3,9.6,9.7,9.6h41.3c5.3,0,9.7-4.3,9.7-9.6V18.2C79,12.9,74.7,8.6,69.3,8.6z M76,84.4c0,3.7-3,6.6-6.7,6.6H28c-3.7,0-6.7-3-6.7-6.6V18.2c0-3.7,3-6.6,6.7-6.6h41.3c3.7,0,6.7,3,6.7,6.6V84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "phone-fill",
    d: "M60.9,18.1H36.2c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h24.7c0.8,0,1.5-0.7,1.5-1.5S61.7,18.1,60.9,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "phone-fill",
    d: "M48.6,75.4c-2.8,0-5,2.3-5,5c0,1.3,0.5,2.6,1.5,3.5c0.9,0.9,2.2,1.4,3.5,1.4c0,0,0,0,0,0c2.8,0,5-2.3,5-5C53.6,77.6,51.4,75.4,48.6,75.4z M48.7,82.4C48.7,82.4,48.7,82.4,48.7,82.4c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4c0-1.1,0.9-2,2-2c0,0,0,0,0,0c1.1,0,2,0.9,2,2C50.7,81.5,49.8,82.4,48.7,82.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "done-icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "phone-fill",
    d: "M346.704,99.096c-0.664-1.4-2.064-2.528-3.608-2.528h-30.464V5.312c0-2.208-3.548-4.172-5.752-4.172l1.752-0.572H203.108           c-2.208,0-2.476,2.536-2.476,4.744v91.256h-33.376c-1.54,0-2.944,1.124-3.6,2.524c-0.66,1.392-0.456,3.28,0.516,4.476           l87.924,107.256c0.756,0.924,1.884,1.444,3.088,1.444c1.188,0,2.328-0.568,3.084-1.488l87.912-107.328           C347.152,102.256,347.356,100.488,346.704,99.096z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "coin-shape"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8.5,
    fill: "#fff",
    className: "coin-stroke"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 2.6,
    fontSize: 7.2,
    fontFamily: "'IBM Plex Sans Arabic', 'Akatab', sans-serif",
    textAnchor: "middle",
    className: "coin-text",
    fontWeight: 700
  }, "\u062F\u062C")), /*#__PURE__*/React.createElement("path", {
    id: "centerPath",
    d: "M84 54 L244 54",
    fill: "none",
    stroke: "none"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftPhone",
    transform: "translate(40,12) scale(0.9)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("use", {
    href: "#phone-shape"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 44,
    height: 48,
    rx: 2,
    ry: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0.6;1;0.6",
    keyTimes: "0;0.60;0.88;1",
    dur: "2s",
    begin: "0s",
    repeatCount: "indefinite"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rightPhone",
    transform: "translate(200,12) scale(0.9)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("use", {
    href: "#phone-shape"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 44,
    height: 48,
    rx: 2,
    ry: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.6;0.6;1;0.6",
    keyTimes: "0;0.60;0.88;1",
    dur: "2s",
    begin: "0.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("g", {
    id: "doneInScreen",
    transform: "translate(16,26) scale(0.11)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("use", {
    href: "#done-icon"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;0",
    keyTimes: "0.60;0.88;1",
    dur: "3s",
    begin: "0.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    additive: "sum",
    values: "0.96;1.08;1",
    keyTimes: "0;0.60;0.88",
    dur: "3s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "coins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin1",
    transform: "translate(84,54)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#coin-shape"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.8s",
    begin: "0s",
    repeatCount: "indefinite",
    fill: "freeze",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#centerPath"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.12;0.82;1",
    dur: "1.8s",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    values: "1;0.82;0.62",
    keyTimes: "0;0.5;1",
    dur: "1.8s",
    begin: "0s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin2",
    transform: "translate(84,54)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#coin-shape"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.8s",
    begin: "0.6s",
    repeatCount: "indefinite",
    fill: "freeze",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#centerPath"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.12;0.82;1",
    dur: "1.8s",
    begin: "0.6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    values: "1;0.82;0.62",
    keyTimes: "0;0.5;1",
    dur: "1.8s",
    begin: "0.6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin3",
    transform: "translate(84,54)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#coin-shape"
  }), /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.8s",
    begin: "1.2s",
    repeatCount: "indefinite",
    fill: "freeze",
    rotate: 0
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#centerPath"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.12;0.82;1",
    dur: "1.8s",
    begin: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    values: "1;0.82;0.62",
    keyTimes: "0;0.5;1",
    dur: "1.8s",
    begin: "1.2s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedTransfert);
export default __webpack_public_path__ + "static/media/animatedTransfert.514bab01.svg";
export { ForwardRef as ReactComponent };